;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "cRTSNx83MP"							}), success: c, error: e});						}, cb  = function(section, $) {/*---start js vendors---*/;var cb  = function($) {
   var  _this = jQuery(this),
        _dom  = _this.closest('.lh-blog-section'),
      popup_sidebar = _this.find('.lh-popup-sidebar');
  $(window).resize(function(){
    if($(window).width() >= 992) {
      _dom.hasClass('lh-mobile') && _dom.removeClass('lh-mobile');
      _dom.hasClass('lh-show') && _dom.removeClass('lh-show');
    }
    else
      !_dom.hasClass('lh-mobile') && _dom.addClass('lh-mobile');
  }).trigger('resize');
  popup_sidebar.click(function(){
    _dom.toggleClass('lh-show');
  });
  _this.find('.lh-sidebar-close a , .lh-sidebar-overlay').click(function(){
    _dom.removeClass('lh-show');
  })

 };						cb.bind($('section[data-section-id="cRTSNx83MP"] include[data-name="content"][data-id="1"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="cRTSNx83MP"]').get(0))({						url: "https://app.layouthub.com/DEV.nosync/TEAMWORK/huynh-duc/deru-blog_75/Deru/blog/",						settings: {}					}, jQuery);})(jQuery);